import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import PageError from '../components/PageError';

const NotFoundPage = () => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = t('Page not found');
        // Définir le statut HTTP à 404
        if (typeof window !== 'undefined') {
            const event = new CustomEvent('http-status', { detail: 404 });
            window.dispatchEvent(event);
        }
    }, [t]);

    return (
        <PageError
            title={t('Page not found')}
            message={t('The page you are looking for does not exist.')}
        />
    );
};

export default NotFoundPage;